module.exports = __webpack_public_path__ + "static/img/10.023d48f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/sp/10.png
// module id = DzqB
// module chunks = 0